import { environmentConfig } from "@src/appV2/environment";

export const CANCELLATION_PROTECTION_PAYOUTS_URL = `${environmentConfig.REACT_APP_BASE_API_URL}/cancellation-protection-payouts`;
